// extracted by mini-css-extract-plugin
export var block = "Heading-module--block--Oc34-";
export var center = "Heading-module--center--XpW+A";
export var left = "Heading-module--left--aqAK0";
export var right = "Heading-module--right--q5TyI";
export var root = "Heading-module--root--sHzFd";